import TaskListWrapper from "../TaskListWrapper";

export default function OngoingList({ list }) {
  return <TaskListWrapper data={list} />;
}
